
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"vimeo\" ><title>vimeo</title><g data-name=\"Layer 2\"><path d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\"/><path d=\"M17.76 9.36c-.65 3.66-4.28 6.76-5.38 7.47s-2.09-.28-2.45-1S8.28 10.31 8 9.92s-1.3.38-1.3.38l-.47-.62S8.16 7.32 9.67 7s1.59 2.45 2 4 .62 2.33.94 2.33.95-.83 1.62-2.1 0-2.39-1.36-1.6c.53-3.19 5.55-4 4.9-.3\"/></g></symbol>";
module.exports = sprite.add(image, "vimeo");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/vimeo.svg
// module id = 670
// module chunks = 1474